"use strict";

exports.__esModule = true;
exports.sortBy = exports.filterByType = exports.filterBy = void 0;
var _escapeRegExp = require("./escapeRegExp");
var _constants = require("../Components/Logbook/constants");
var sortBy = exports.sortBy = function sortBy(arr, key) {
  if (arr.length > 0 && key !== "") {
    return arr.sort(function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    });
  }
  return arr;
};

// filters array by supplied key value
var filterByType = exports.filterByType = function filterByType(arr, selectedTypes) {
  if (selectedTypes.length > 0) {
    return arr.filter(function (item) {
      return selectedTypes.some(function (type) {
        return type === item.type;
      });
    });
  }
  return [];
};

// filters by title & creator if type is ticket || body and creator if type is comment
// case insensitive
var filterBy = exports.filterBy = function filterBy(arr, searchTerm) {
  if (searchTerm && searchTerm !== "") {
    return arr.filter(function (item) {
      if (item.type === _constants.LOGBOOK_TICKET) {
        return new RegExp((0, _escapeRegExp.escapeRegExp)(searchTerm), "gi").test(item.title) || new RegExp((0, _escapeRegExp.escapeRegExp)(searchTerm), "gi").test(item.creator) || new RegExp((0, _escapeRegExp.escapeRegExp)(searchTerm), "gi").test(item.id);
      } else if (item.type === _constants.LOGBOOK_COMMENT) {
        return new RegExp((0, _escapeRegExp.escapeRegExp)(searchTerm), "gi").test(item.body) || new RegExp((0, _escapeRegExp.escapeRegExp)(searchTerm), "gi").test(item.creator);
      }
      return false;
    });
  }
  return arr;
};